import React from 'react'
import styles from './EyRnButton.module.scss';

export default function EyRnButton({size}: any) {
const btnSize = { "--size": size? `${size/16}rem` : '2.18rem' } as React.CSSProperties;
  return (
    <button style={btnSize} className={styles.chatToggleBtn}></button>
  )
}
